import { createAction } from 'redux-actions';
export const SET_RESTRICTIONS = 'SET_RESTRICTIONS';
export const SET_RESTRICTIONS_LOADING = 'SET_RESTRICTIONS_LOADING';
export const SET_RESTRICTIONS_ACCEPTED = 'SET_RESTRICTIONS_ACCEPTED';
export const setRestrictions = createAction(SET_RESTRICTIONS);
export const setRestrictionsLoading = createAction(SET_RESTRICTIONS_LOADING);
export const setRestrictionsAccepted = createAction(SET_RESTRICTIONS_ACCEPTED);
